import { useState, useEffect } from "react";
// --------------------- Import Services ---------------------

import { buscarCotasUsuario } from "../../../services/buscarCotasUsuario";

// --------------------- Import Interfaces ---------------------
import { Usuario } from "../Interfaces/Usuario";
import { CotaUsuario } from "../../../interfaces/CotaUsuario";
import { formatStatus } from "../../../uteis/statusFormatted";

export const useProprietariosStatus = () => {
  const [proprietarioStatus, setProprietariStatus] = useState<CotaUsuario[]>(
    []
  );
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUsuarios = async () => {
      const data = await buscarCotasUsuario();

      const propriedadesArray = data.map((p: Usuario) => {
        return {
          key: p.id,
          status: formatStatus(p.status),
        };
      });

      setProprietariStatus(propriedadesArray);
      setIsLoading(false);
    };

    fetchUsuarios();
  }, []);

  return { proprietarioStatus, isLoading };
};
